export default "__VITE_ASSET__Dx$X0$V3__ 1200w";